const currencyList = [
    { value: "gbp", label: "GBP - £" },
    { value: "eur", label: "EUR - €" },
    { value: "usd", label: "USD - $" },
];

export { currencyList };
